import { emailMarketingIntegration } from 'ducks/entities/schema'

export const emailMarketingIntegrationsNormalizationSchema = {
  emailMarketingIntegrations: {
    nodes: [emailMarketingIntegration],
  },
}

export const emailMarketingIntegrationMailboxSettingNormalizationSchema = emailMarketingIntegration
